import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	alignItems: "center",
	gap: "8",
	marginBottom: "16",
});
